<template>
    <div>
        <div>
            <app-header :closeable="true" :title="'enter the password'"></app-header>

            <section class="container">
                <div class="intro-content pt--40 pb--40">
                    <img src="/img/logo-title.png" alt="" class="intro-content__logo"/>
                </div>

                <div class="mb--lg">
                    <input type="text" v-model="password" :placeholder="'password'" @keyup.enter="auth()"
                           class="form-control mb--md">
                    <button type="button" @click="auth()" class="btn btn--block btn--primary">Enter</button>
                </div>
            </section>
        </div>

        <modal ref="wrongPasswordModal" type="error" show="false">
            <template v-slot:title>Error!</template>
            <template v-slot:message>
                Incorrect password, please try again!
            </template>
            <template v-slot:buttons>
                <a href="#" @click.prevent="$refs.wrongPasswordModal.close()" class="btn btn--block btn--secondary">Close</a>
            </template>
        </modal>
    </div>
</template>

<script>
import channelAuth from "../../../api/channelAuth";
import AppHeader from "../../partial/AppHeader";

export default {
    components: {AppHeader},
    props: {
        code: {
            default: '',
        }
    },

    data: function () {
        return {
            password: null,
            passwordError: false,
        }
    },

    methods: {
        auth() {
            channelAuth.auth(this.code, this.password).then(() => {
                this.$router.go();
            }).catch((error) => {
                if (error.response.status > 400) {
                    this.passwordError = true
                    this.$refs.wrongPasswordModal.open()
                }
            })
        }
    }
}
</script>